<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" v-for="vehicle in vehicles" :key="vehicle.id">
        <v-card tile @click="openListing(vehicle.id)">
          <div
            class="d-flex flex-no-wrap justify-space-between flex-column flex-sm-row"
          >
            <!-- Show the first image only on small screens -->
            <v-avatar
              v-if="$vuetify.breakpoint.smAndDown"
              class="ma-3 mx-auto d-block"
              size="240"
              tile
            >
              <v-img :src="vehicle.adImage" :style="{ width: '100%' }"></v-img>
            </v-avatar>

            <div class="text-center text-sm-left">
              <v-card-title class="text-h6 text--primary">{{
                removeNonEnglishCharacters(vehicle.title)
              }}</v-card-title>

              <!-- Show price or 'SOLD' image based on conditions -->
              <template v-if="vehicle.price !== 'SOLD'">
                <v-card-text>
                  <p class="text-h4" style="color: #4cd4ca">
                    ${{ vehicle.price }}*
                  </p>
                  <p class="text-medium-emphasis text-caption">
                    *Estimated Landed Price in AUD
                  </p>
                </v-card-text>
              </template>
              <template v-else>
                <v-card-text
                  v-if="$vuetify.breakpoint.smAndDown"
                  class="text-center"
                >
                  <p class="text-h4" style="color: #4cd4ca">
                    <v-img
                      src="../assets/sold.png"
                      width="120"
                      class="mx-auto"
                    ></v-img>
                  </p>
                </v-card-text>
                <v-card-text
                  v-if="$vuetify.breakpoint.mdAndUp"
                  class="text-center"
                >
                  <p class="text-h4" style="color: #4cd4ca">
                    <v-img src="../assets/sold.png" width="120"></v-img>
                  </p>
                </v-card-text>
              </template>

              <div class="text--primary text--justify text-body-2 pl-4 pr-4">
                {{ truncateAndReplaceText(vehicle.description) }}
              </div>

              <v-card-actions>
                <VehicleModal
                  :vehicle="vehicle"
                  :selectedVehicle="selectedVehicle"
                  :handleClose="clearSelectedVehicle"
                  :isInWishlist="isInWishlist(vehicle.id)"
                  :addOrRemoveFromWishlist="addOrRemoveFromWishlist"
                />
                <v-btn class="ml-2" outlined rounded small color="#4cd4ca">
                  Enquire
                </v-btn>
                <v-btn icon @click.stop="addOrRemoveFromWishlist(vehicle)">
                  <v-icon :color="isInWishlist(vehicle.id) ? 'red' : 'grey'">
                    mdi-heart
                  </v-icon>
                </v-btn>
              </v-card-actions>
            </div>

            <v-avatar
              v-if="$vuetify.breakpoint.mdAndUp"
              class="ma-3"
              size="240"
              tile
            >
              <v-img :src="vehicle.adImage" height="300"></v-img>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { doc, setDoc, getDoc } from "firebase/firestore";
import { db, auth } from "../../firebase";
import VehicleModal from "./VehicleModal.vue";

export default {
  components: {
    VehicleModal,
  },
  props: {
    vehicles: Array,
  },
  created() {
    // Check if the user is logged in
    const user = auth.currentUser;
    if (user) {
      // Fetch the user's wishlist from the database
      const userRef = doc(db, "users", user.uid);
      getDoc(userRef).then((doc) => {
        if (doc.exists()) {
          this.wishlist = doc.data().wishlist;
        }
      });
    }
  },
  data() {
    return {
      selectedVehicle: null,
      wishlist: [],
    };
  },
  methods: {
    openListing(vehicle) {
      // Set the selected vehicle and open the dialog
      this.selectedVehicle = vehicle;
    },
    clearSelectedVehicle() {
      // Clear the selected vehicle when the dialog is closed
      this.selectedVehicle = null;
    },
    removeNonEnglishCharacters(title) {
      // Remove non-English characters and the phrase "(Free Global Shipping)" using a regular expression
      return title
        .replace(/[^A-Za-z0-9\s]/g, "")
        .replace(/Free Global Shipping/g, "");
    },
    truncateAndReplaceText(description) {
      // Perform "find and replace"
      const replacedText = description.replace(/51GT3/g, "GT-Collective");

      // Truncate the description to a specified length (e.g., 150 characters)
      const maxLength = 150;
      if (replacedText.length > maxLength) {
        return replacedText.substring(0, maxLength) + "...";
      }
      return replacedText;
    },
    isInWishlist(vehicleId) {
      // Check if the vehicle is in the user's wishlist
      const user = auth.currentUser;
      return user && this.wishlist && this.wishlist.includes(vehicleId);
    },
    addOrRemoveFromWishlist(vehicle) {
      // Add or remove the vehicle from the user's wishlist
      const user = auth.currentUser;
      if (user && user.uid) {
        const wishlist = this.wishlist;
        const vehicleId = vehicle.id;

        // Check if the vehicle is already in the wishlist
        if (wishlist.includes(vehicleId)) {
          // Remove the vehicle from the wishlist
          const index = wishlist?.indexOf(vehicleId);
          if (index > -1) {
            wishlist.splice(index, 1);
          }
        } else {
          // Add the vehicle to the wishlist
          wishlist.push(vehicleId);
        }

        // Update the user's wishlist in the database
        const userRef = doc(db, "users", user.uid);
        setDoc(userRef, { wishlist: wishlist }, { merge: true });
      }
    },
  },
};
</script>
